import { FormikProps } from "formik";
import { DashboardViewFormValues } from "../../../types/dashboardForm";
import { HStack, VStack, Box, Input, Stack } from "@chakra-ui/react";
import { SelectAnalyte } from "../SelectAnalyte/SelectAnalyte";
import { SelectSites } from "../SelectSites/SelectSites";
import { ProjectID } from "../../../types/project";
import { parse } from "date-fns";

export function DashboardForm({
  formik,
  project,
}: {
  formik: FormikProps<DashboardViewFormValues>;
  project: ProjectID;
}) {
  const { startDate, endDate, sites } = formik.values;
  return (
    <VStack alignItems={"stretch"}>
      <Stack direction={{ base: "column", md: "row" }} alignItems={"stretch"}>
        <HStack>
          <Box flex="1">
            <Input
              id="startDate"
              placeholder="Start Date"
              size="md"
              type="date"
              value={startDate}
              onChange={formik.handleChange}
            />
          </Box>

          <Box flex="1">
            <Input
              id="endDate"
              placeholder="End Date"
              size="md"
              type="date"
              value={endDate}
              onChange={formik.handleChange}
            />
          </Box>
        </HStack>

        <Box flex="1">
          {sites && sites.length > 0 && (
            <SelectAnalyte
              formik={formik}
              project={project}
              sites={sites}
              startDate={parse(startDate, "yyyy-MM-dd", new Date())}
              endDate={parse(endDate, "yyyy-MM-dd", new Date())}
            />
          )}
        </Box>
      </Stack>
      <SelectSites formik={formik} project={project} />
    </VStack>
  );
}
